import {
  getWhatsappThreadDisplayState,
  getWhatsappThreadStateI18nKey,
  WHATSAPP_THREAD_DISPLAY
} from '@/pages/contacts/whatsappThreadDisplay'

/**
 * Configuration d’affichage (Element UI el-tag) pour la colonne Qualification (état thread WhatsApp).
 * @param {string} displayKey valeur de WHATSAPP_THREAD_DISPLAY
 * @returns {{ elTagType: string, effect: 'light'|'dark'|'plain', i18nKey: string }}
 */
export function getContactQualificationBadgeConfig (displayKey) {
  switch (displayKey) {
    case WHATSAPP_THREAD_DISPLAY.COMPLETED:
      return {
        elTagType: 'success',
        effect: 'light',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.UNANSWERED:
      return {
        elTagType: 'info',
        effect: 'plain',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.ABANDONED:
      return {
        elTagType: 'warning',
        effect: 'light',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.IN_PROGRESS:
      return {
        elTagType: 'primary',
        effect: 'light',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.PENDING:
      return {
        elTagType: 'info',
        effect: 'light',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.OPERATOR_REQUESTED:
      return {
        elTagType: 'warning',
        effect: 'light',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.ERROR:
      return {
        elTagType: 'danger',
        effect: 'light',
        i18nKey: getWhatsappThreadStateI18nKey(displayKey)
      }
    case WHATSAPP_THREAD_DISPLAY.UNKNOWN:
    default:
      return {
        elTagType: 'info',
        effect: 'dark',
        i18nKey: getWhatsappThreadStateI18nKey(WHATSAPP_THREAD_DISPLAY.UNKNOWN)
      }
  }
}

/**
 * @param {{ threads?: unknown[] }} row ligne contact_mailtracking
 * @returns {string} clé WHATSAPP_THREAD_DISPLAY
 */
export function getContactQualificationStateFromRow (row) {
  return getWhatsappThreadDisplayState(row)
}
